import CJT from './CJT';

export default CJT;
